export default "__VITE_ASSET__CkdIzZDm__"